module.exports = __webpack_public_path__ + "static/assets/0f1feb8570cba8353844fc5747783d8f.png";